import {Grid} from '@visx/grid';
import React from 'react';

import {isVisxAxisConfigScaleType, VisxAxisConfig} from './utils/getVisxAxisConfig';
import {DEFAULT_GRID_LINE_STYLE} from './utils/Theme';
import {VisxScaleType} from './VisxUtilityTypes';

export interface ChartGridProps {
  xAxisConfig: VisxAxisConfig;
  yAxisConfig: VisxAxisConfig;
  width: number;
  height: number;
}

export default function ChartGrid({xAxisConfig, yAxisConfig, width, height}: ChartGridProps): JSX.Element {
  return (
    <Grid
      xScale={xAxisConfig.scale}
      yScale={yAxisConfig.scale}
      width={width}
      height={height}
      numTicksColumns={xAxisConfig.suggestedNumTicks}
      numTicksRows={yAxisConfig.suggestedNumTicks}
      xOffset={isVisxAxisConfigScaleType(xAxisConfig, VisxScaleType.BAND) ? xAxisConfig.scale.step() / 2 : 0}
      {...DEFAULT_GRID_LINE_STYLE}
    />
  );
}
